import React from 'react';
import { Plus, Pencil, Trash2, Users } from 'lucide-react';
import { Button } from '../ui/button';
import { formatDateTime } from './adminConstants';

export function AdminManagersSection({ 
    managers, 
    onOpenNewModal, 
    onEdit, 
    onDelete 
}) {
    return (
        <div className="space-y-6" data-testid="admin-managers">
            <div className="flex justify-between items-center">
                <h2 className="text-2xl font-bold">Managers</h2>
                <Button onClick={onOpenNewModal} data-testid="add-manager-btn">
                    <Plus className="w-4 h-4 mr-2" />
                    Add Manager
                </Button>
            </div>

            <div className="text-sm text-muted-foreground">
                {managers.length} managers total
            </div>
            
            <div className="space-y-3">
                {managers.map(manager => (
                    <div key={manager.id} className="card-base" data-testid={`manager-card-${manager.id}`}>
                        <div className="flex flex-col md:flex-row md:items-center justify-between gap-4">
                            <div className="flex-1">
                                <p className="font-bold text-lg">{manager.name}</p>
                                <p className="text-sm text-muted-foreground">{manager.email}</p>
                                <p className="text-xs text-muted-foreground">
                                    Created: {formatDateTime(manager.created_at)}
                                </p>
                            </div>
                            <div className="flex gap-2 flex-shrink-0">
                                <Button 
                                    variant="outline" 
                                    size="sm" 
                                    onClick={() => onEdit(manager)}
                                    data-testid={`edit-manager-${manager.id}`}
                                    title="Edit Manager"
                                >
                                    <Pencil className="w-4 h-4" />
                                </Button>
                                <Button 
                                    variant="destructive" 
                                    size="sm" 
                                    onClick={() => onDelete(manager)}
                                    data-testid={`delete-manager-${manager.id}`}
                                    title="Delete Manager"
                                >
                                    <Trash2 className="w-4 h-4" />
                                </Button>
                            </div>
                        </div>
                    </div>
                ))}
                
                {managers.length === 0 && (
                    <div className="card-base text-center py-12">
                        <Users className="w-12 h-12 text-muted-foreground mx-auto mb-3" />
                        <p className="text-muted-foreground">No managers yet</p>
                        <Button onClick={onOpenNewModal} className="mt-4">
                            Add First Manager
                        </Button>
                    </div>
                )}
            </div>
        </div>
    );
}
